import styled from 'styled-components';
import { JoinInput } from '../../components/items/joinInput';
import { Button } from '../../components/items/Button';
import { CommonTitle } from '../../components/items/common.title';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { AlertModal } from '../../components/modal/alert.modal';
import { passwordChangeSchema } from '../../schema/mypageSchema';
import { changeCompanyPassword, changeUserPassword } from '../../api/mypage';
import { useHistory } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { authState } from '../../atoms/authState';
import axios from 'axios'; // 기본 axios 모듈에서 isAxiosError 가져오기

interface ChangePasswordProps {
  oldPassword: string;
  newPassword: string;
  newPasswordConfirm: string;
}

const PasswordChange = () => {
  const auth = useRecoilValue(authState);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [navigateOnClose, setNavigateOnClose] = useState(false); // 페이지 이동 여부를 추적
  const history = useHistory(); // useHistory 훅 사용

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ChangePasswordProps>({
    resolver: zodResolver(passwordChangeSchema),
  });

  const handleModalClose = () => {
    setIsModalOpen(false);
    if (navigateOnClose) {
      history.push({
        pathname: '/mypage',
      }); // navigateOnClose가 true일 때만 /mypage로 이동
    }
  };

  const onSubmit = async (data: ChangePasswordProps) => {
    try {
      let response;

      if (auth.userType === 'driver') {
        response = await changeUserPassword(data);
      } else if (auth.userType === 'company') {
        response = await changeCompanyPassword(data);
      }

      if (response && response.statusCode === 200) {
        setModalMessage(response.message);
        setNavigateOnClose(true); // 비밀번호 변경이 성공하면 페이지 이동 설정
      } else {
        setModalMessage('비밀번호 변경에 실패했습니다.');
        setNavigateOnClose(false); // 실패 시 페이지 이동을 하지 않도록 설정
      }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 400) {
        setModalMessage(error.response.data.message);
      }
      //setModalMessage('비밀번호 변경 중 오류가 발생했습니다.');
      setNavigateOnClose(false); // 오류 발생 시 페이지 이동을 하지 않도록 설정
    } finally {
      setIsModalOpen(true);
    }
  };

  return (
    <Container>
      <CommonTitle
        title="비밀번호 변경"
        subTitle={`비빌번호는 영문자와 숫자를 조합하여 8~20자로 \n입력해주세요.`}
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <JoinInput
          name="oldPassword"
          label="현재 비밀번호"
          placeholder="비밀번호 입력"
          type="password"
          errors={
            errors.oldPassword?.message
              ? [errors.oldPassword.message as string]
              : []
          }
          register={register}
        />
        <JoinInput
          name="newPassword"
          label="신규 비밀번호"
          placeholder="비밀번호 입력"
          type="password"
          errors={
            errors.newPassword?.message
              ? [errors.newPassword.message as string]
              : []
          }
          register={register}
        />
        <JoinInput
          name="newPasswordConfirm"
          label="신규 비밀번호 확인"
          placeholder="비밀번호 입력 확인"
          type="password"
          errors={
            errors.newPasswordConfirm?.message
              ? [errors.newPasswordConfirm.message as string]
              : []
          }
          register={register}
        />
        <Button title="비밀번호 변경" type="submit" fiexd />
      </form>
      {isModalOpen && (
        <AlertModal
          handleConfirmClose={handleModalClose}
          confirmText={modalMessage}
          onClick={handleModalClose}
        />
      )}
    </Container>
  );
};

export default PasswordChange;

// style
const Container = styled.div`
  padding: 2.4rem 2rem;
  form {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
  }
`;
